"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.StarComponent = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const AssetsService_1 = __importStar(require("@front/services/AssetsService"));
const client_1 = require("@rws-framework/client");
//@ts-ignore                
let rwsTemplate = T.html `<div     
    class="app-star${x => x.full ? ' is-full' : ''}"
    style="--star-width: ${x => !x.width ? 'auto' : x.width}; --star-height: ${x => !x.height ? 'auto' : x.height}; --star-color: ${x => x.starColor};"
    :innerHTML="${x => x.svgContent}"
></div>`;
require("./styles/layout.scss");
const styles = T.css `:host {
  display: inline-block;
}

.app-star {
  width: var(--star-width);
  height: var(--star-height);
}
.app-star svg {
  width: var(--star-width);
  height: var(--star-height);
}
.app-star.is-full svg {
  display: block;
}
.app-star.is-full svg path {
  fill: var(--star-color);
}`;
const shadowOptions = { "mode": "open" };
let StarComponent = class StarComponent extends client_1.RWSViewComponent {
    constructor(assetsService) {
        super();
        this.assetsService = assetsService;
        this.full = false;
        this.width = null;
        this.height = null;
        this.emptyStarColor = '#000'; // Default star color (gold)
        this.fullStarColor = 'var(--primary-color)'; // Default star color (gold)
        this.svgContent = null;
    }
    async connectedCallback() {
        super.connectedCallback();
        if (this.full) {
            this.starColor = this.fullStarColor;
        }
        else {
            this.starColor = this.emptyStarColor;
        }
        await this.getStarSVG();
    }
    async getStarSVG() {
        this.svgContent = await this.assetsService.getAsset('/assets/images/star.svg');
    }
};
exports.StarComponent = StarComponent;
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], StarComponent.prototype, "full", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], StarComponent.prototype, "width", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], StarComponent.prototype, "height", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], StarComponent.prototype, "emptyStarColor", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], StarComponent.prototype, "fullStarColor", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], StarComponent.prototype, "svgContent", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], StarComponent.prototype, "starColor", void 0);
exports.StarComponent = StarComponent = __decorate([
    (0, client_1.RWSView)('app-star', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(AssetsService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof AssetsService_1.AssetsServiceInstance !== "undefined" && AssetsService_1.AssetsServiceInstance) === "function" ? _a : Object])
], StarComponent);
StarComponent.defineComponent();
